import React from 'react';  
import { connect } from 'react-redux'
import Form from 'react-bootstrap/Form'
import Image from 'react-bootstrap/Image'
import { ACT_GOTLOGS, ACT_FN_SETLOGTOEDIT, ACT_CANCELADDLOGS, ACT_GOTPROJECTS, ACT_GOTRECENTPROJECTS } from './actions.js';
import {  ACT_LOGOUT } from './actions.js'
import moment from 'moment';  
import { WL, WL_SUCCESS, WL_FAIL, WL_EXCEPTION, WL_UNAUTHORIZED } from './WebLoggerService.jsx'
import $ from 'jquery'
import Card from 'react-bootstrap/Card'
import TooltipButton from './TooltipButton.jsx'
import Badge from 'react-bootstrap/Badge'
import Select from 'react-virtualized-select'
import ReactQueryParams from 'react-query-params'
import 'react-select/dist/react-select.css';
import 'react-virtualized/styles.css'
import 'react-virtualized-select/styles.css'
import Spinner from 'react-bootstrap/Spinner'
import { refreshRecentProjects } from './projects.jsx'

class Logging extends ReactQueryParams /*React.Component*/ {  

	constructor(props) {
		super(props)
		this.state = {
			allProjectInfo: [], allProjectItemInfo:[],
			optionalCommentProjects:[],
			/*projects: [],*/ projects2: [], /*projectitems: [],*/ projectitems2: [], 
			projectId: (props.lastLog === undefined ? undefined : props.lastLog.projectId),
			projectItemId: (props.lastLog === undefined ? -1 : props.lastLog.projectItemId),
			duration: (props.lastLog === undefined ? 1 : props.lastLog.duration),
			distance: (props.lastLog === undefined ? 0 : props.lastLog.distance),
			comments: (props.lastLog === undefined ? '' : props.lastLog.comments),
			location: (props.lastLog === undefined ? '' : props.lastLog.location),
			compensationAbroad: (props.lastLog === undefined ? '0' : props.lastLog.compensationAbroad),
			compensation: (props.lastLog === undefined ? false : props.lastLog.compensation),
			homework: (props.lastLog === undefined ? false : props.lastLog.homework),
			durationInHours: false,
			waitcursor:false
		}
		this.saveLog = this.saveLog.bind(this)
		this.setLogToEdit = this.setLogToEdit.bind(this)
		this.AddLogResult = this.AddLogResult.bind(this)
		this.GetLogsResult = this.GetLogsResult.bind(this)
		this.UpdateLogResult = this.UpdateLogResult.bind(this)
		this.GetProjectsResult = this.GetProjectsResult.bind(this)
		this.GetProjectItemsResult = this.GetProjectItemsResult.bind(this)
	}

	componentDidMount() {
		if (this.state.projects2.length === 0) {
			//console.log("GETTING PROJECTS")
			//console.log("Current projID = " + this.state.projectId)
			//console.log("WL_GetProjects with token " + this.props.token)
			WL.GetProjects(this.props.token, "user", this.GetProjectsResult, {})
		}
		this.props.dispatch({ type: ACT_FN_SETLOGTOEDIT, fn: this.setLogToEdit })

		//console.log("Querystring=" + JSON.stringify(decodeURI(this.queryParams.desc)))
		//console.log("Querystring=" + JSON.stringify(decodeURI(this.queryParams.projectItem)))

		if (this.queryParams.desc !== undefined) this.setState({ comments: decodeURIComponent(this.queryParams.desc) })
		if (this.queryParams.projectItem !== undefined) {
			let parts = decodeURIComponent(this.queryParams.projectItem).split(" - ")
			console.log("parsing parts:"+parts)
			if (parts[0] !== undefined) {
				let projectId = parseInt(parts[0])
				if (projectId !== undefined) {
					console.log("found project id:" + projectId)
					this.setState({ projectId })
				}
			}
			for (let i = 1; i < parts.length; i++) {
				if (parts[i] !== undefined ) {
					let projectItemId = parseInt(parts[i])
					if (projectItemId !== undefined && !isNaN(projectItemId)) {
						console.log("found projectitem id:" + projectItemId)
						this.setState({ projectItemId })
						break;
					}
				}
			}
		}
	}
	
	
	fillFormFields(log) {
		if (log.projectId !== this.state.projectId) {
			this.fillProjectItems(log.projectId)
		}
		let arrPrjs = $.grep(this.state.allProjectInfo, (p) => (p.id === log.projectId))
		let duration = log.duration
		//console.log("project=" + arrPrjs)
		if (arrPrjs.length > 0) {

			if (arrPrjs[0].showLogsInHours) {
				//console.log("Converting to hours...")
				duration = duration * 8
				duration = Math.round(duration * 1000) / 1000
				//console.log("converted duration:" + duration)
			}
			this.setState({ durationInHours: arrPrjs[0].showLogsInHours })
		}
		this.setState({
			projectId: log.projectId,
			projectItemId: log.projectItemId,
			duration,
			location: log.location,
			distance: log.distance,
			comments: log.comments,
			logId: log.logId,
			logDate: log.startDate,
			homework: log.homework,
			compensation: log.compensation,
			compensationAbroad: log.compensationAbroad
		})
	}

	setLogToEdit(log) {
		this.fillFormFields(log)
	}

	
	fillProjectItems(project_id)
	{
		//console.log("GETTING PROJECTITEMS")
		//WL_GetProjectItems(this.props.token, project_id, this.GetProjectItemsResult)
		WL.GetProjectItems(this.props.token, project_id, this.GetProjectItemsResult)
	}

	GetProjectItemsResult(result, data) {
		if (result === WL_UNAUTHORIZED) {
			this.props.logout()
		} else if (result === WL_EXCEPTION) {
			this.setState({ showError: true, errMsg: "Failed to contact the server" })
		} else if (result === WL_FAIL) {
			this.setState({ showError: true, errMsg: "Failed to retrieve the projectitems" })
		} else if (result === WL_SUCCESS) {
			let idToCheck = this.state.projectItemId
			let idSelected
			//let lst = []
			let lst2 = []
			data.forEach(function (prjItem, index, array) {
				/*lst.push(
					<option key={prjItem.id} value={prjItem.id}>
						{prjItem.name}
					</option>)*/
				lst2.push({	value:  prjItem.id , label: prjItem.name})
				if (idToCheck === prjItem.id) {
					idSelected = prjItem.id;
				}
			})

			this.setState({ /*projectitems: lst,*/ projectitems2: lst2, allProjectItemInfo: data })
			if (idSelected === undefined && data.length>0) {
				this.setState({ projectItemId: data[0].id})
			}
			//console.log("got project items")
		}
	}

	GetProjectsResult(result, data, recentProjects) {
		if (result === WL_UNAUTHORIZED) {
			this.props.logout()
		} else if (result === WL_EXCEPTION) {
			this.setState({ showError: true, errMsg: "Failed to contact the server" })
		} else if (result === WL_FAIL) {
			this.setState({ showError: true, errMsg: "Failed to retrieve the projects" })
		} else if (result === WL_SUCCESS) {
			
			if (recentProjects.userProjects === undefined) {
				this.props.GotRecentProjects(data);
				WL.GetProjects(this.props.token, "firm", this.GetProjectsResult, { userProjects: data })
			}
			else if (recentProjects.firmProjects === undefined) {
				WL.GetProjects(this.props.token, "all", this.GetProjectsResult, { ...recentProjects, firmProjects: data })
			}
			else {
				let emptyCommentProject = []
				let noDistanceProjects = []
				let firstProjectId
				//let lst = []
				let lst2 = []

				//recent projects
				if (recentProjects.userProjects.length > 0) {
					firstProjectId = recentProjects.userProjects[0].id
					recentProjects.userProjects.forEach(function (prj, index, array) {
						/*lst.push(
							<option key={100000+prj.id} value={prj.id}>
								{prj.name}
							</option>)*/
						lst2.push({ value: prj.id, label: prj.name })
					})
					//lst.push(<option key={100000} value={0} disabled>──────────────────────────</option>)
					lst2.push({ value: 100000, label: "──────────────────────────" })
				}

				//firm projects
				if (recentProjects.firmProjects.length > 0) {
					recentProjects.firmProjects.forEach(function (prj, index, array) {
						/*lst.push(
							<option key={200000+prj.id} value={prj.id}>
								{prj.name}
							</option>)*/
						lst2.push({ value: prj.id, label: prj.name })
					})
					//lst.push(<option key={200000} value={0} disabled>──────────────────────────</option>)
					lst2.push({ value: 200000, label: "──────────────────────────" })
				}

				//all projects
				data.forEach(function (prj, index, array) {
					/*lst.push(
						<option key={prj.id} value={prj.id} label={prj.name}>
							{prj.name}
						</option>)*/
					lst2.push({ value: prj.id, label: prj.name })

					//console.log("***project id="+prj.id+" - type="+typeof(prj.id))
					let prjName = prj.name.toLowerCase()
					if (prjName.indexOf('ziek') >= 0 || prjName.indexOf('verlof') >= 0 || (prj.logCommentsRequired!==true)) {
						emptyCommentProject.push(prj.id)
						//console.log("Found empty comment project: ["+prj.id+"] "+prj.name)
					}
					if (prjName.indexOf('ziek') >= 0 || prjName.indexOf('verlof') >= 0 ) {
						noDistanceProjects.push(prj.id)
						//console.log("Found empty comment project: ["+prj.id+"] "+prj.name)
					}
				})

				//lst.sort()
				this.setState({ /*projects: lst,*/ projects2: lst2, optionalCommentProjects: emptyCommentProject, noDistanceProjects, allProjectInfo:data})
				if (this.state.projectId !== undefined) {
					
					this.fillProjectItems(this.state.projectId)
				}
				else {
					//console.log("No project ID set")
					//console.log("firstProjectId : " + firstProjectId)
					if (firstProjectId !== undefined) {
						//console.log("selecting first recent project:" + firstProjectId)
						this.projectSelected(firstProjectId)
					}
					else if (data.length > 0) {
						//console.log("selecting first project:" + data[0].id)
						this.projectSelected(data[0].id)
					}
				}
				//send project data to other components
				this.props.gotAllProjects(data)
			}
		}
	}

	projectSelected(projectId) {

		let duration = this.state.duration
		//console.log("initial duration:"+duration)
		/*let arrPrjs = $.grep(this.state.allProjectInfo, (p) => (p.id === this.state.projectId))
		//console.log("project=" + arrPrjs)
		if (arrPrjs.length > 0) {
			if (arrPrjs[0].showLogsInHours) {
				console.log("Converting to days...")
				duration = duration / 8
			}
			console.log("converted duration:" + duration)
		}
		*/
		if (this.state.durationInHours) {
			//console.log("Converting to days...")
			duration = duration / 8
			//console.log("duration:" + duration)
		}

		this.setState({ projectId })
		/*let arrPrjOptions = $.grep(this.state.projects, (p) => (p.value === projectId))
		if (arrPrjOptions.length > 0) {
			this.setState({ projectOption: arrPrjOptions[0]})
		}*/

		this.fillProjectItems(projectId)

		let arrPrjs = $.grep(this.state.allProjectInfo, (p) => (p.id === projectId))
		//console.log("project=" + arrPrjs)
		if (arrPrjs.length > 0) {
			
			if (arrPrjs[0].showLogsInHours) {
				//console.log("Converting to hours...")
				duration = duration * 8
				duration = Math.round(duration * 1000) / 1000
				console.log("converted duration:" + duration)
			}
			this.setState({ durationInHours: arrPrjs[0].showLogsInHours })
			
		}
		this.setState({duration})
	}
	
	
    
	render() {
		//console.log("logging: "+JSON.stringify(this.state))
		var commentsReqOption = {}
		var hideDistance=false
		
		//if (this.state.optionalCommentProjects.find((e) => (e === this.state.projectId)) === undefined) {
		if ($.inArray(this.state.projectId, this.state.optionalCommentProjects) === -1) {
			commentsReqOption = { required: "required" }
		}
		

		if ($.inArray(this.state.projectId, this.state.noDistanceProjects) !== -1) {
			hideDistance = true
		}
		

		let prj
		let projectBadge = ''
		let projectItemBadge = ''

		let arrPrjs = $.grep(this.state.allProjectInfo, (p) => (p.id === this.state.projectId))
		//console.log("project=" + arrPrjs)
		if (arrPrjs.length > 0) {
			prj = arrPrjs[0]
		}

		if (prj) {
			let variant = "info"
			if (!prj.regie) {
				variant = "success"
				if (prj.done > prj.budget) {
					variant = "danger"
				}
			}

			projectBadge = < Badge pill variant={variant} > {prj.done + "d"+ (prj.regie?"":(" / " + prj.budget + "d"))}</Badge>

			//console.log("looking for pi-id :"+ this.state.projectItemId)
			let arrPrjItems = $.grep(this.state.allProjectItemInfo, (pi) => (pi.id === this.state.projectItemId))
			//console.log("projectitem=" + arrPrjItems)
			if (arrPrjItems.length > 0) {
				let prjItem = arrPrjItems[0]
				variant = "info"
				if (!prj.regie) {
					variant = "success"
					if (prjItem.done > prjItem.budget) {
						variant = "danger"
					}
				}
				projectItemBadge = < Badge pill variant={variant} > {prjItem.done + "d" + (prj.regie ? "" : (" / " + prjItem.budget + "d"))}</Badge>
			}
		
		}
		let logRange = !(this.props.endDate === null || this.props.startDate.isSame(this.props.endDate))
		return ( 
			<>
			<div style={this.state.waitcursor ? { pointerEvents: "none", opacity: "0.3" } : {}}>
				<Form onSubmit={this.saveLog}>
					<Card style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
						< Card.Header >
							{logRange &&
								<Card.Title>
									Daily Log Details For {this.props.startDate.format("DD/MM/YYYY") + " till " + this.props.endDate.format("DD/MM/YYYY")}
								</Card.Title>
							}
							{!logRange &&
								<Card.Title>
									Log Details For { this.props.startDate.format("DD/MM/YYYY") }
								</Card.Title>
							}
						</Card.Header>
						<Card.Body style={{ paddingBottom: "0px" }} >
						
							<Form.Group controlId="exampleForm.Project">
								<Form.Label>Project&nbsp;{projectBadge}</Form.Label>
								{/*<Form.Control as="select" value={this.state.projectId} onChange={(event) => { this.projectSelected(parseInt(event.target.value)) }} required >
									{this.state.projects}
								</Form.Control>*/}
								{<Select  
									value={this.state.projectId}
									onChange={(selectedOption) => { if (selectedOption!==null) this.projectSelected(selectedOption.value ) }}
									options={this.state.projects2}/>}
							</Form.Group>
							<Form.Group controlId="exampleForm.ProjectItem">
								<Form.Label>Project Task&nbsp;{projectItemBadge}</Form.Label>
								{/*<Form.Control as="select" onChange={(event)=>{this.setState({projectItemId:parseInt(event.target.value)});}} required value={this.state.projectItemId}>
								{this.state.projectitems}
								</Form.Control>*/}
								{<Select
									value={this.state.projectItemId}
									onChange={(selectedOption) => { if (selectedOption !== null) this.setState({ projectItemId: parseInt(selectedOption.value) }) }}
									options={this.state.projectitems2} />}
							</Form.Group>
							<Form.Row >
								<Form.Group controlId="exampleForm.Duration" className="mr-2 ml-1" required >
									<Form.Label>Time in {(prj && prj.showLogsInHours) ? "hours" : "days (1d=8h)"}</Form.Label>
									<Form.Control as="input" value={this.state.duration} onInput={(event) => { this.validateDuration(event.target, prj.showLogsInHours) }} onChange={(event) => { this.setState({ duration: event.target.value.replace(',','.') })/*this.setState({ duration: (event.target.value / ((prj && prj.showLogsInHours) ? 8 : 1))})*/}}/>
								</Form.Group>
								<Form.Group controlId="exampleForm.Location" className="mr-2" style={{ display: (hideDistance === true) ? "none" : "" }}>
									<Form.Label>Location</Form.Label>
									<Form.Control as="input" value={this.state.location} onChange={(event) => { this.setState({ location: event.target.value }); }}/>
								</Form.Group>
								<Form.Group controlId="exampleForm.Distance" className="mr-2" style={{ display: (hideDistance === true) ? "none" : "" }}>
									<Form.Label>Distance with private car (km)</Form.Label>
									<Form.Control as="input" value={this.state.distance} onInput={(event) => {  this.validateDistance(event.target) }} onChange={(event) => { this.setState({ distance: event.target.value }) }}/>
								</Form.Group>
							</Form.Row>
							<Form.Row >
								<Form.Group controlId="exampleForm.CompensationAbroad" className="mr-2">
									<Form.Label>Compensation stay abroad (€/day)</Form.Label>
									<Form.Control as="input" value={this.state.compensationAbroad} onInput={(event) => {  this.validateCompensationAbroad(event.target) }} onChange={(event) => { this.setState({ compensationAbroad: event.target.value }) }}/>
								</Form.Group>
								<Form.Group controlId="exampleForm.Compensation" className="mr-2">
									<Form.Label></Form.Label>
									<Form.Check type="checkbox" label="Day compensation" checked={this.state.compensation} onChange={(event) => { this.setState({ compensation: event.target.checked }) }}/>
								</Form.Group>
								<Form.Group controlId="exampleForm.Homework" >
									<Form.Label></Form.Label>
									<Form.Check type="checkbox" label="Homework" checked={this.state.homework} onChange={(event) => { this.setState({ homework: event.target.checked }) }}/>
								</Form.Group>
							</Form.Row>
							<Form.Group controlId="exampleForm.Comments">
							<Form.Label>Description</Form.Label>
								<Form.Control as="textarea" rows="5" value={this.state.comments} {...commentsReqOption} onChange={(event) => { this.setState({ comments: event.target.value }) }} />
						
								</Form.Group>
							
						</Card.Body>
						<Card.Footer >
							<div className="text-right">
								<TooltipButton className="mr-2" variant="outline-light" tooltiptext="Cancel" onClick={() => this.props.cancel()} content={<Image alt="Cancel" src="back.png" style={{ width: "32px" }} />}/>
								{
									(this.props.logToCopy.projectId === undefined) ? null :
										<TooltipButton className="mr-2" variant="outline-light" tooltiptext="Paste" onClick={() => this.fillFormFields(this.props.logToCopy)} content={<Image alt="Paste" src="sheet.png" style={{ width: "32px" }} />}/>
								}
								<TooltipButton variant="outline-light" type="submit" tooltiptext="Save"
									content={<Image alt="Save"
										src={
											(this.props.endDate !== null && this.props.startDate !== null && !this.props.endDate.isSame(this.props.startDate) && this.state.logId === undefined) ?
												"savesave.png" : "save.png"
										}
										style={{ width: "32px" }}
									/>}
								/>
							</div>
						</Card.Footer>
					</Card>
				</Form>
				</div>
				{this.state.waitcursor && <Spinner style={{ position: "fixed", top: "50%", left: "50%", marginTop: "-50px", marginLeft: "-25px" }} animation="grow" variant="primary" />}
			</>

		    );  
	}  

	validateDuration(input, logHours) {
		var duration = Number(input.value)
		
		if (isNaN(duration) || duration <= 0) {
			input.setCustomValidity("Please enter a duration > 0.")
		} else if (logHours && duration > 24) {
			input.setCustomValidity("Please enter a duration <=24h")
		} else if (!logHours && duration > 3) {
			input.setCustomValidity("Please enter a duration <=3d")
		} else {
			input.setCustomValidity("")
		}
	}

	validateDistance(input) {
		var distance = Number(input.value)

		if (isNaN(distance) || distance < 0) {
			input.setCustomValidity("Please enter a distance > 0 km.")
		} else {
			input.setCustomValidity("")
		}
	}
	validateCompensationAbroad(input) {
		var amount = Number(input.value)

		if (isNaN(amount) || amount < 0) {
			input.setCustomValidity("Please enter an amount >= 0 ")
		} else {
			input.setCustomValidity("")
		}
	}
	
	saveLog(event) {
		console.log("saveLog called...")
		event.preventDefault()

		let arrPrjs = $.grep(this.state.allProjectInfo, (p) => (p.id === this.state.projectId))
		//console.log("project=" + arrPrjs)
		if (arrPrjs.length <= 0) {
			console.log("Could not find project in own list...What happened???")
		}
		let prj = arrPrjs[0]
		
		var startDate = this.props.startDate
		var endDate = this.props.endDate
		if (endDate === null) endDate = startDate

		console.log("saving logging for date:" +this.props.startDate.format("DD/MM/YYYY") +" to "+((this.props.endDate===null)?'':this.props.endDate.format("DD/MM/YYYY")))
				
		var projectId = /*parseInt(event.target["exampleForm.Project"].value)*/ this.state.projectId
		//var projectName = event.target["exampleForm.Project"].options[event.target["exampleForm.Project"].selectedIndex].text
		var projectItemId = /*parseInt(event.target["exampleForm.ProjectItem"].value)*/ this.state.projectItemId
		//var projectItemName = event.target["exampleForm.ProjectItem"].options[event.target["exampleForm.ProjectItem"].selectedIndex].text
		var duration = event.target["exampleForm.Duration"].value / (prj.showLogsInHours?8:1)
		var comments = event.target["exampleForm.Comments"].value
		var location = ''
		var distance = 0
		if ($.inArray(projectId, this.state.noDistanceProjects) === -1) {
			location = event.target["exampleForm.Location"].value
			distance = parseInt(event.target["exampleForm.Distance"].value)
		}
		var compensationAbroad = event.target["exampleForm.CompensationAbroad"].value
		var compensation = event.target["exampleForm.Compensation"].checked
		var homework = event.target["exampleForm.Homework"].checked

		this.setState({waitcursor:true})		
		if (this.state.logId===undefined)
		{
			console.log("Adding log..."+comments)
			WL.AddLogs(this.props.token, { logId:0, projectId, /*projectName,*/ projectItemId, /*projectItemName,*/ 
				duration, location, distance, comments, 
				startDate: startDate.format("YYYY-MM-DD"), endDate: endDate.format("YYYY-MM-DD"), 
				compensation, compensationAbroad, homework }, this.AddLogResult)
		}
		else
		{
			console.log("Updating log..." + moment(this.state.logDate).format("YYYY-MM-DD"))
			WL.UpdateLog(this.props.token, { logId: this.state.logId, projectId, /*projectName,*/ projectItemId, /*projectItemName,*/ 
				duration, location, distance, comments, 
				startDate: moment(this.state.logDate).format("YYYY-MM-DD")/*startDate.format("YYYY-MM-DD"), endDate: endDate.format("YYYY-MM-DD")*/ , 
				compensation, compensationAbroad, homework}, this.UpdateLogResult)
			this.setState({logId:undefined})
		}
	}

	AddLogResult(result, data) {
		if (result !== WL_SUCCESS) {
			this.setState({ waitcursor: false })
		}
		if (result === WL_UNAUTHORIZED) {
			this.props.logout()
		} else if (result === WL_EXCEPTION) {
			this.setState({ showError: true, errMsg: "Failed to contact the server" })
		} else if (result === WL_FAIL) {
			this.setState({ showError: true, errMsg: "Failed to add the log" })
		} else if (result === WL_SUCCESS) {
			WL.GetLogs(this.props.token, this.GetLogsResult)
			refreshRecentProjects(this.props.token);
		}
	}

	UpdateLogResult(result, data) {
		if (result !== WL_SUCCESS) {
			this.setState({ waitcursor: false })
		}
		if (result === WL_UNAUTHORIZED) {
			this.props.logout()
		} else if (result === WL_EXCEPTION) {
			this.setState({ showError: true, errMsg: "Failed to contact the server" })
		} else if (result === WL_FAIL) {
			this.setState({ showError: true, errMsg: "Failed to update the log" })
		} else if (result === WL_SUCCESS) {
			WL.GetLogs(this.props.token, this.GetLogsResult)
		}
	}


	GetLogsResult(result, data) {
		this.setState({ waitcursor: false })
		if (result === WL_UNAUTHORIZED) {
			this.props.logout()
		} else if (result === WL_EXCEPTION) {
			console.log("Exception while getting logs")
		} else if (result === WL_FAIL) {
			console.log("Failed to get logs")
		} else if (result === WL_SUCCESS) {
			this.props.gotLogs(data)

		}
	}
    
}  


function mapDispatchToProps(dispatch) {
	return {
		logout: () => {dispatch({ type: ACT_LOGOUT })},
		gotLogs: (data) => { dispatch({ type: ACT_GOTLOGS, logs: data }) },
		gotAllProjects: (data) => { dispatch({ type: ACT_GOTPROJECTS, projects: data }) },
		GotRecentProjects: (data) => { dispatch({ type: ACT_GOTRECENTPROJECTS, recentProjects: data }) },
		cancel: () => { dispatch({ type: ACT_CANCELADDLOGS }) }
		
	}
}

function mapStateToProps(state) {
	var startDate = state.period.startDate === null ? null : moment(state.period.startDate).startOf("day")
	var endDate = state.period.endDate === null ? null : moment(state.period.endDate).startOf("day")
	var logToCopy = $.extend({}, { ...state.logging.logToCopy });
	delete logToCopy.logId
	return {dispatch: state.app.dispatch, startDate, endDate, token: state.user.userInfo["token"], logToCopy}
	
}
  
export default connect(mapStateToProps,mapDispatchToProps)(Logging);  